// Backup AB flag schema for offline/fallback scenarios
// This should be updated periodically from your AB flag service
export default [
    {
        flagName: 'lowerHouseholdIncomeLimit',
        probabilityTrue: 0,
    },
] as any[];
